import React from 'react';
import styles from './index.css';
class MoreTabs extends React.PureComponent {
    render() {
        const { title, moreUrl } = this.props;
        return (React.createElement("div", { className: styles.more_tabs },
            React.createElement("div", { className: styles.title }, title),
            React.createElement("a", { className: styles.more, href: moreUrl },
                React.createElement("span", null, "\u66F4\u591A"),
                React.createElement("span", null))));
    }
}
export default MoreTabs;
